<template>
  <v-card>
    <v-card-text>
      <form id="advancedSearchForm" @submit="handleSubmit">
        <v-container fluid grid-list-lg class="ma-0 pa-0" :style="{ width: '100% !important' }">
          <v-layout wrap>
            <v-flex xs12 md4 class="form-control">
              <label class="caption">{{ $t('employee_id_abbr') }}</label>
              <input v-model="form.employee_id" name="employee_id" type="text" />
            </v-flex>
            <v-flex xs12 md4 class="form-control">
              <label class="caption">{{ $t('name') }}</label>
              <input v-model="form.username" name="username" type="text" />
            </v-flex>
            <v-flex xs12 md4 class="form-control">
              <label class="caption">{{ $t('position') }}</label>
              <multiselect
                v-model="form.position"
                name="position"
                :options="positionOptions()"
                label="label"
                track-by="value"
                :searchable="false"
                :show-labels="false"
              ></multiselect>
            </v-flex>
            <v-flex xs12 md4 class="form-control">
              <label class="caption">{{ $t('department') }}</label>
              <multiselect
                v-model="form.department"
                name="department"
                :options="departmentOptions()"
                label="label"
                track-by="value"
                :searchable="false"
                :show-labels="false"
              ></multiselect>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
    <v-card-actions :style="{ justifyContent: 'flex-end' }">
      <v-btn @click="clear()">{{ $t('Clear search') }}</v-btn>
      <v-btn color="primary" type="submit" form="advancedSearchForm">
        <v-icon>search</v-icon>
        {{ $t('Search') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: { Multiselect },
  inject: ['positionOptions', 'departmentOptions'],
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        employee_id: this.value.employee_id,
        username: this.value.username,
        position: this.value.position,
        department: this.value.department
      }
    }
  },
  methods: {
    handleSubmit(event) {
      event.preventDefault()
      this.submit()
    },
    submit() {
      this.$emit('input', { ...this.value, ...this.form, page: 1 })
    },
    clear() {
      this.form = {
        employee_id: '',
        username: '',
        position: null,
        department: null
      }
      this.submit()
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/member/AdvancedSearch.vue